import conn from "@/store/utils/connection";
import resulter from "@/store/utils/resulter";
import api from "../apiEndPoint";

export default {
  getWhitelabel: async ({ commit }) => {
    let res = await conn
      .get(api.getCheckWhitelabel)
      .then((response) => {
        if (response.data.code === 200) {
          if (response.data.status) {
            commit("setWhitelabel", response.data.data);
            commit("setResponse", response.data.code);
          } else {
            commit("setResponse", resulter.errorResult(response.data.msg));
          }
          return response;
        }
      })
      .catch((e) => {
        commit("setResponse", resulter.errorResult(e));
      });
    return res;
  },

  getDetail: ({ commit }, query) => {
    conn
      .get(api.getDetailPesanan + "?id_pesanan=" + query)
      .then((response) => {
        if (response.data.code === 200) {
          if (response.data.status) {
            commit("setDetailPesanan", response.data.data);
          } else {
            commit("setResponse", resulter.errorResult(response.data.msg));
          }
        }
      })
      .catch((e) => {
        commit("setResponse", resulter.errorResult(e));
      });
    return response;
  },

  dataOwner: async ({ commit }) => {
    let res = await conn
      .get(api.getDataDetailOwner)
      .then((response) => {
        if (response.data.code === 200) {
          if (response.data.status) {
            commit("setDataOwner", response.data.data);
            commit("setResponse", response.data.code);
          } else {
            commit("setResponse", resulter.errorResult(response.data.msg));
          }
          return response;
        }
      })
      .catch((e) => {
        commit("setResponse", resulter.errorResult(e));
      });
    return res;
  },

  detailPembayaranUser: async ({ commit }, query) => {
    let res = await conn
      .get(api.getDetailPembayaran + "?id_cicilan=" + query)
      .then((response) => {
        if (response.data.code === 200) {
          if (response.data.status) {
            commit("setDetailBayar", response.data.data);
            commit("setResponse", response.data.code);
          } else {
            commit("setResponse", resulter.errorResult(response.data.msg));
          }
          return response;
        }
      })
      .catch((e) => {
        commit("setResponse", resulter.errorResult(e));
      });
    return res;
  },

  dataBank: async ({ commit }) => {
    let res = await conn
      .get(api.getDataBank)
      .then((response) => {
        if (response.data.code === 200) {
          if (response.data.status) {
            commit("setDataPembayaran", response.data.data);
            commit("setResponse", response.data.code);
          } else {
            commit("setResponse", resulter.errorResult(response.data.msg));
          }
          return response;
        }
      })
      .catch((e) => {
        commit("setResponse", resulter.errorResult(e));
      });
    return res;
  },
};
